import { formatDate } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Share } from "@capacitor/share";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { DialogService } from "src/app/providers/dialog.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { MessagingService } from "src/app/providers/messaging.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SharedService } from "src/app/providers/shared.service";
import { AddCustomerComponent } from "src/app/shared/components/add-customer/add-customer.component";
import { CreateInvoiceForCustomersComponent } from "src/app/shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { FollowerChatComponent } from "src/app/shared/components/follower-chat/follower-chat.component";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: 'sm-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent implements OnInit, OnDestroy {
  isAccessForEmployeeInvoice: boolean = false;

  cData: any;
  isOwner: boolean = false;
  customerData: any = [];
  loader: boolean = false;

  apisub: Subscription;
  constructor(
    private navservice: NavigationService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private loaderservice: LoaderServiceService,
    private translateService: TranslateService,
    private router: Router,
    private dialogService: DialogService,
    private authService: AuthService,
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_CUSTOMER_DETAILS
      ) {
        this.customerData = [];
        if (resData.result) {
          resData.result.total_wallet =
            typeof resData.result.total_wallet == "string"
              ? JSON.parse(resData.result.total_wallet)
              : resData.result.total_wallet;

          this.customerData.push(resData.result);
          this.customerData.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }
          });
        }
        sessionStorage.setItem("mefrp", this.customerData[0].email);
        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
          ),
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resData.result) {
          this.discountInfo = resData.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_CUSTOMER_DATA
      ) {
        if (resData.result) {
          this.router.navigate(["../"], {
            relativeTo: this.route,
            queryParamsHandling: "preserve",
          });
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
        }
      }

      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID) {
        if (this.isFromThis) {
          this.isFromThis = false;
          this.previousChatHash = null;
          // this.chatThreads = []
          if (resData.result) {
            resData.result.forEach((element: any) => {
              if (element.senderInfo && element.receiverInfo) {
                if (
                  element.senderInfo &&
                  typeof element.senderInfo == "string"
                ) {
                  element.senderInfo = JSON.parse(element.senderInfo);
                }
                if (
                  element.receiverInfo &&
                  typeof element.receiverInfo == "string"
                ) {
                  element.receiverInfo = JSON.parse(element.receiverInfo);
                }
                if (
                  (element.senderInfo.hash_id == this.senderHashId &&
                    element.receiverInfo.hash_id == this.receiverHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
                      )) ||
                  (element.senderInfo.hash_id == this.receiverHashId &&
                    element.receiverInfo.hash_id == this.senderHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
                      ))
                ) {
                  this.previousChatHash = element.hash_id;
                }
              }
            });
            console.log(this.previousChatHash);
          }
          this.loaderservice.showLoader = false;
          let data = {
            title: this.selectedFollowerName,
            ref: this.dialog,
            previousChatHash: this.previousChatHash,
            followerImage: this.selectedFollowerImg,
            folowerProfileHash: this.selectedFollowerProfileHash, //
          };
          this.dialogService.openFullScreenDialog(FollowerChatComponent, data);
        }
      }
    });
  }
  discountInfo: any;
  isEntityIndividual: any;

  entityHash: any;
  countryCode: any;
  phone: any;
  name: any;

  ngOnInit(): void {
    this.loaderservice.showLoader = true;
    this.loader = true;
    this.isOwner = this.authService.isOwner();
    this.isEntityIndividual = sessionStorage.getItem("isEntityIndividual");

    if (this.isOwner) {
      this.isAccessForEmployeeInvoice = true;
    } else {
      const ssa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      );
      const hsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      );
      const vsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      );

      const bsss = sessionStorage.getItem("shop_service_status");
      const bhss = sessionStorage.getItem("home_service_status");
      const bvss = sessionStorage.getItem("virtual_service_status");

      // sessionStorage.getItem() returns a string or null.

      // 2. Check if ANY of the retrieved values is the string '1'
      if (
        (ssa == "1" && bsss != "2") ||
        (hsa == "1" && bhss != "2") ||
        (vsa == "1" && bvss != "2")
      ) {
        this.isAccessForEmployeeInvoice = true;
      }
    }
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.entityHash = data.entityHash;
        this.countryCode = data.countryCode;
        this.phone = data.phone;
        this.name = data.name;
      }
    });

    this._apiService.getCustomerDetails(
      this.entityHash,
      this.countryCode,
      this.phone,
      this.name,
    );
  }

  openAllBookings(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { phone: item.phone, mn: item.name },
    });
  }
  openAllPayments(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
      },
    });
  }
  openDueBookings(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["due-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { phone: item.phone, mn: item.name },
    });
  }
  msg: any;

  openPaymentIntimation(item: any) {
    let data = {
      title: "Payment Intimation",
      ref: this._modelRef,
      data: item,
      type: 1,
      entity_hash: this.entityHash

    }
    this.dialogService.openFullScreenDialog(PaymentIntimationComponent,data);
  }

  createInvoice(customer: any) {
    let data = {
      title: "New Invoice",
      ref: this._modelRef,
      data: {
        entityHash: this.entityHash,
        eph: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
        ),
        customer: customer,
        discountInfo: this.discountInfo,
      },
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this.dialogService.openFullScreenDialog(
      CreateInvoiceForCustomersComponent,
      data,
    );
  }

  deleteCustomer(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this customer?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.loaderservice.showLoader = true;
        this._apiService.deleteEntityCustomer(obj);
      }
    });
  }

  selectedFollowerName: any;
  selectedFollowerImg: any;
  selectedFollowerProfileHash: any;
  previousChatHash: any = null;
  senderHashId: any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH);
  receiverHashId: any;
  isFromThis: boolean = false;
  openMessages(rowvalue: any) {
    this.isFromThis = true;
    this.selectedFollowerName = rowvalue.name;
    this.selectedFollowerImg = rowvalue.image_thumb_url;
    this.selectedFollowerProfileHash = rowvalue.profile_hash_id;
    this.receiverHashId = rowvalue.profile_hash_id;
    this.loaderservice.showLoader = true;
    this._apiService.getMessagesByID();
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  editCustomer(rowvalue: any) {
    console.log(this.cData);

    let data = {
      customerData: rowvalue,
      entityHash: this.entityHash,
      link: "",
      title: "Add customer",
    };
    let dialogref = this.dialogService.openFullScreenDialog(
      AddCustomerComponent,
      data,
    );
    dialogref.afterClosed().subscribe((res) => {
      if (res.resData) {
        if (res.resData[0].errorcode == 1) {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another customer with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
           this.loaderservice.showLoader = true;
          this._apiService.getCustomerDetails(
            this.entityHash,
            this.countryCode,
            this.phone,
            this.name,
          );
        }
      }
    });
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  openwallemoney(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["customer-wallet-money"], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        memail: item.email,
      },
    });
  }

  openrewardpoint(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["reward-points"], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        memail: item.email,
      },
    });
  }
}
